import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const ReceiptsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.receipts.totalReceiptsCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
